export const getInvolved = {
  hero: {
    badge: "Faire la Différence",
    title: "Rejoignez-nous pour Transformer des Vies",
    subtitle: "Chaque contribution, qu'il s'agisse de temps ou de ressources, nous aide à apporter espoir et dignité aux réfugiés et aux communautés vulnérables en RDC."
  },
  donation: {
    title: "Faire un Don",
    subtitle: "Votre soutien financier a un impact direct sur les vies. Choisissez comment vous souhaitez contribuer.",
    oneTime: "Unique",
    recurring: "Mensuel",
    amounts: {
      custom: "Montant Personnalisé"
    },
    button: "Faire un Don",
    secure: "Paiement sécurisé par Stripe"
  },
  volunteer: {
    title: "Devenir Bénévole",
    subtitle: "Rejoignez notre équipe de bénévoles dévoués qui font une réelle différence sur le terrain.",
    form: {
      fullName: "Nom Complet",
      fullNamePlaceholder: "Entrez votre nom complet",
      email: "Adresse Email",
      emailPlaceholder: "votre.email@exemple.com",
      phone: "Numéro de Téléphone",
      phonePlaceholder: "+256 XXX XXX XXX",
      location: "Votre Localisation",
      locationPlaceholder: "Ville, Pays",
      skills: "Compétences et Expertise",
      skillsPlaceholder: "ex: Médical, Enseignement, Construction, Administration...",
      availability: "Disponibilité",
      availabilityPlaceholder: "ex: Week-ends, Temps plein, 2 semaines par mois...",
      motivation: "Pourquoi voulez-vous être bénévole?",
      motivationPlaceholder: "Dites-nous ce qui vous motive à rejoindre notre mission...",
      submit: "Soumettre la Candidature",
      submitting: "Envoi en cours...",
      successMessage: "Merci! Nous vous contactons bientôt.",
      errorMessage: "Une erreur s'est produite. Veuillez réessayer."
    }
  },
  campaigns: {
    title: "Campagnes de Collecte de Fonds Actives",
    subtitle: "Soutenez des initiatives spécifiques qui ont un impact immédiat.",
    raised: "collecté",
    goal: "objectif",
    donors: "donateurs",
    daysLeft: "jours restants",
    share: "Partager la Campagne"
  },
  partnership: {
    title: "Partenariat avec Nous",
    subtitle: "Les organisations et entreprises peuvent amplifier notre impact grâce à des partenariats stratégiques.",
    form: {
      orgName: "Nom de l'Organisation",
      orgNamePlaceholder: "Nom de votre organisation",
      contactName: "Personne de Contact",
      contactNamePlaceholder: "Nom complet",
      email: "Adresse Email",
      emailPlaceholder: "contact@organisation.com",
      phone: "Numéro de Téléphone",
      phonePlaceholder: "+XXX XXX XXX XXX",
      partnershipType: "Type de Partenariat",
      partnershipTypePlaceholder: "ex: Parrainage d'entreprise, Don en nature, Programme de bénévolat...",
      message: "Parlez-nous de votre intérêt",
      messagePlaceholder: "Décrivez comment vous souhaitez vous associer avec nous et quelles ressources vous pouvez offrir...",
      submit: "Envoyer la Demande",
      submitting: "Envoi...",
      successMessage: "Merci! Nous vous contacterons bientôt.",
      errorMessage: "Échec de l'envoi. Veuillez réessayer."
    }
  }
};
